/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.02.25 10:33.
* @Author
* @Description 辽宁点播项目 - 入口
**/
<template>
    <div :class="{w100: !terminalM}" id="app">
        <!-- 头部 -->
        <header-nav></header-nav>
        <div class="w1200">
            <router-view/>
        </div>
        <!-- 脚部 -->
        <footer-nav></footer-nav>
    </div>
</template>
<script>
import HeaderNav from '@/views/Header/'
import FooterNav from '@/views/Footer/'

export default {
  name: 'App',
  components: { HeaderNav, FooterNav },
  data () {
    return {
      terminalM: true,
    }
  },
  created () {
    this.getTerminal()
  },
  mounted () {
  },
  methods: {
    /**
     *@Description
     *@Param
     *@Return 获取终端类型.
     **/
    getTerminal () {
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { // 移动端
        console.log('移动端')
        this.terminalM = false
        localStorage.setItem('terminalM', 'ph')
      } else {
        this.terminalM = true
        localStorage.setItem('terminalM', 'pc')
        console.log('pc')
      }
    }
  }
}
</script>
<style lang="scss">
    * {
        margin: 0;
        padding: 0;
    }
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        font-size: 14px;
        color: #2c3e50;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    li {
        list-style: none;
    }
    .w1200 {
        width: 1200px;
        margin: 10px auto;
    }
    .el-pagination {
        text-align: center;
    }
    /* 针对移动端 样式重置 */
    .w100 {
        box-sizing: border-box;
        width: 100%;
        .w1200 {
            width: 100%;
            margin: 0;
        }
        /* 课程查询条件 */
        .ln-query {
            padding: 0 10px;
            .el-form-item {
                margin-bottom: 10px;
            }
        }
        /* 课程列表 */
        .ln-list {
            li {
                float: none;
                width: 100%;
                height: auto;
                margin-bottom: 10px;
                margin-left: 0;
                padding: 0;
                border-bottom: 1px solid #eee;
                img {
                    height: 150px;
                }
                span {
                    width: calc(100% - 70px);
                }
            }
        }
    }
</style>
